import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api, { resolveImageUrl } from "@/lib/api";
import { ArrowRight } from "lucide-react";

export default function Solutions() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/solutions").then((r) => setItems(r.data || [])).catch(() => {});
  }, []);

  return (
    <div data-testid="solutions-page">
      <section className="bg-white border-b border-msr-line">
        <div className="msr-container py-16 lg:py-20 grid lg:grid-cols-12 gap-10 items-end">
          <div className="lg:col-span-7">
            <div className="overline mb-3">MSR Solutions Catalog</div>
            <h1 className="font-heading font-extrabold text-4xl lg:text-6xl tracking-tight text-msr-ink leading-[1.05]" data-testid="solutions-title">
              Ready-made enterprise<br />platforms for your operations.
            </h1>
          </div>
          <p className="lg:col-span-5 text-msr-slate leading-relaxed">
            Eight specialized platforms covering payroll, document management, facilities, field operations, sales, customer service, procurement, and learning — designed for the Filipino business context, deployable in the cloud or on-premise.
          </p>
        </div>
      </section>

      <section className="bg-msr-surface border-b border-msr-line">
        <div className="msr-container py-16 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {items.map((s, i) => (
            <Link key={s.id} to={`/solutions/${s.slug}`} className="msr-card group hover:-translate-y-1 transition-transform" data-testid={`solution-card-${s.slug}`}>
              <div className="msr-corner" aria-hidden />
              <div className="relative -mx-6 -mt-6 lg:-mx-8 lg:-mt-8 mb-5 h-44 overflow-hidden">
                <img src={resolveImageUrl(s.featured_image)} alt={s.name} className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-500" />
                <span className="absolute top-3 left-3 badge-soft-blue bg-white/95">{s.category}</span>
                <span className="absolute top-3 right-3 text-[10px] font-bold tracking-[0.18em] uppercase text-white bg-msr-ink/80 px-2 py-1">{String(i + 1).padStart(2, "0")}</span>
              </div>
              <h2 className="font-heading font-extrabold text-2xl text-msr-ink">{s.name}</h2>
              <p className="text-xs text-msr-slate font-medium mb-2 uppercase tracking-wider">{s.full_name}</p>
              <p className="text-sm text-msr-slate leading-relaxed line-clamp-3 mb-5">{s.short_description}</p>
              <div className="inline-flex items-center gap-1.5 text-msr-blue font-semibold text-sm">
                Open solution <ArrowRight size={14} />
              </div>
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
}
